module.exports = __webpack_public_path__ + "SHSADCAA/static/media/store.783bbdc4.svg";